import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ApiWaveDecision } from "@/generated/models/ApiWaveDecision";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
interface UseWaveDecisionsProps {
  readonly wave: ApiWave;
  readonly enabled?: boolean | undefined;
}
export function useWaveDecisions(t0) {
  const $ = _c(15);
  const {
    wave,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  let t3;
  if ($[0] !== wave.id) {
    t2 = [QueryKey.WAVE_DECISIONS, {
      waveId: wave.id
    }];
    t3 = async () => await commonApiFetch({
      endpoint: `waves/${wave.id}/decisions`,
      params: {
        sort_direction: "DESC",
        sort: "decision_time",
        page: "1",
        page_size: "100"
      }
    });
    $[0] = wave.id;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  const t4 = enabled && !!wave.id;
  let t5;
  if ($[3] !== t2 || $[4] !== t3 || $[5] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4,
      staleTime: 60000
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const {
    data,
    isError,
    error,
    refetch,
    isFetching
  } = useQuery(t5);
  let t6;
  if ($[7] !== data?.data) {
    t6 = data?.data.map(_temp2).sort(_temp3) || [];
    $[7] = data?.data;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const sortedDecisionPoints = t6;
  let t7;
  if ($[9] !== error || $[10] !== isError || $[11] !== isFetching || $[12] !== refetch || $[13] !== sortedDecisionPoints) {
    t7 = {
      decisionPoints: sortedDecisionPoints,
      isError,
      error,
      refetch,
      isFetching
    };
    $[9] = error;
    $[10] = isError;
    $[11] = isFetching;
    $[12] = refetch;
    $[13] = sortedDecisionPoints;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function _temp3(a_0, b_0) {
  return a_0.decision_time - b_0.decision_time;
}
function _temp2(data_0) {
  return {
    ...data_0,
    winners: data_0.winners.sort(_temp)
  };
}
function _temp(a, b) {
  return a.place - b.place;
}